import { RectangleStackIcon, FunnelIcon, TableCellsIcon } from '@heroicons/react/16/solid';
import { SaveDropdownProps } from '../types';

export function SaveDropdown({
  hasSearchItems,
  hasFilters,
  hasCustomColumns,
  sourceWeights,
  tab,
  onSaveComplete,
  onSaveSearch,
  onSaveColumnSelection,
  onSaveScore,
}: SaveDropdownProps) {
  return (
    <div
      style={{
        position: 'absolute',
        top: '100%',
        right: 0,
        marginTop: '4px',
        background: 'white',
        border: '1px solid #ddd',
        borderRadius: '6px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        zIndex: 1000,
        minWidth: '240px',
        overflow: 'hidden',
      }}
    >
      <button
        onClick={onSaveComplete}
        disabled={!hasSearchItems && !hasFilters && !hasCustomColumns}
        style={{
          width: '100%',
          padding: '12px 16px',
          border: 'none',
          background: 'white',
          textAlign: 'left',
          cursor: !hasSearchItems && !hasFilters && !hasCustomColumns ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          transition: 'background-color 0.2s',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          opacity: !hasSearchItems && !hasFilters && !hasCustomColumns ? 0.5 : 1,
        }}
        onMouseEnter={e => {
          if (hasSearchItems || hasFilters || hasCustomColumns) {
            e.currentTarget.style.backgroundColor = '#f5f5f5';
          }
        }}
        onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'white')}
      >
        <RectangleStackIcon className="w-5 h-5" />
        <div>
          <div style={{ fontWeight: '600', marginBottom: '2px' }}>Complete Search</div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {!hasSearchItems && !hasFilters && !hasCustomColumns
              ? 'No search to save'
              : 'Search + filters + columns + order'}
          </div>
        </div>
      </button>

      <div style={{ borderTop: '1px solid #eee' }} />

      <button
        onClick={onSaveSearch}
        disabled={!hasFilters}
        style={{
          width: '100%',
          padding: '12px 16px',
          border: 'none',
          background: 'white',
          textAlign: 'left',
          cursor: !hasFilters ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          transition: 'background-color 0.2s',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          opacity: !hasFilters ? 0.5 : 1,
        }}
        onMouseEnter={e => {
          if (hasFilters) {
            e.currentTarget.style.backgroundColor = '#f5f5f5';
          }
        }}
        onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'white')}
      >
        <FunnelIcon className="w-5 h-5" />
        <div>
          <div style={{ fontWeight: '600', marginBottom: '2px' }}>Filters Only</div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {!hasFilters ? 'No filters applied' : 'Save applied filters'}
          </div>
        </div>
      </button>

      <div style={{ borderTop: '1px solid #eee' }} />

      <button
        onClick={onSaveColumnSelection}
        disabled={!hasCustomColumns}
        style={{
          width: '100%',
          padding: '12px 16px',
          border: 'none',
          background: 'white',
          textAlign: 'left',
          cursor: !hasCustomColumns ? 'not-allowed' : 'pointer',
          fontSize: '14px',
          transition: 'background-color 0.2s',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          opacity: !hasCustomColumns ? 0.5 : 1,
        }}
        onMouseEnter={e => {
          if (hasCustomColumns) {
            e.currentTarget.style.backgroundColor = '#f5f5f5';
          }
        }}
        onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'white')}
      >
        <TableCellsIcon className="w-5 h-5" />
        <div>
          <div style={{ fontWeight: '600', marginBottom: '2px' }}>Columns Only</div>
          <div style={{ fontSize: '12px', color: '#666' }}>
            {!hasCustomColumns ? 'No columns customized' : 'Visibility + order'}
          </div>
        </div>
      </button>

      {['GDA', 'VDA'].includes(tab) && sourceWeights.length > 0 && (
        <>
          <div style={{ borderTop: '1px solid #eee' }} />
          <button
            onClick={onSaveScore}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              background: 'white',
              textAlign: 'left',
              cursor: 'pointer',
              fontSize: '14px',
              transition: 'background-color 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#f5f5f5';
            }}
            onMouseLeave={e => (e.currentTarget.style.backgroundColor = 'white')}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
              />
            </svg>
            <div>
              <div style={{ fontWeight: '600', marginBottom: '2px' }}>Score Weights</div>
              <div style={{ fontSize: '12px', color: '#666' }}>Save custom source scores</div>
            </div>
          </button>
        </>
      )}
    </div>
  );
}
